// A standard content band: optional eyebrow/title/lead, then children.
const Section = ({
  eyebrow,
  title,
  lead,
  narrow = false,
  tint = false,
  center = false,
  id,
  children,
}) => (
  <section className={`section${tint ? ' section--tint' : ''}`} id={id}>
    <div className={`container${narrow ? ' container--narrow' : ''}`}>
      {(eyebrow || title || lead) && (
        <div
          className={`section-head reveal${center ? ' section-head--center' : ''}`}
        >
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          {title && <h2 className="section-title">{title}</h2>}
          {lead && <p className="section-lead">{lead}</p>}
        </div>
      )}
      {children}
    </div>
  </section>
);

export default Section;
